import { BasePayloadMapper } from '@ps/utils';

import { ResetPasswordPayloadDto } from '../dtos/auth.dto';
import { ResetPasswordCredentials } from '../../models/auth.model';

export class ResetPasswordPayloadMapper extends BasePayloadMapper<
  ResetPasswordCredentials,
  ResetPasswordPayloadDto
> {
  public toPayload(data: ResetPasswordCredentials): ResetPasswordPayloadDto {
    return {
      oldpass: data.oldPassword,
      newpass: data.newPassword,
      cpass: data.confirmPassword,
    };
  }
}
